/**
 * Refer https://microsoft.visualstudio.com/Edge/_wiki/wikis/Edge.wiki/59516/What-is-Trusted-Types-
 * For trusted-types requirement from edge team
 */
import { purifyHTML } from 'dom-utils/lib/utils/purifyHTML';
// @ts-ignore
if (window.trustedTypes && window.trustedTypes.createPolicy) {
    // Feature testing
    // @ts-ignore
    window.trustedTypes.createPolicy('default', {
        createHTML: purifyHTML,
        createScriptURL: string => string, // warning: this is unsafe!
        /**
         * todo: can put a check for scripts to have following url patterns only
         * *.res.office.com
         * *.res.office365.com
         * *.cdn.office.net
         * *.cdn.partner.outlook.cn
         * owassets.azureedge.net
         * *.blob.core.windows.net
         * outlookdev.azureedge.net
         * shellprod.msocdn.com *.bing.com
         * *.skype.com *.yammer.com
         * *.skypeassets.com
         * *.delve.office.com *.cdn.office.net
         * *.cdn.partner.outlook.cn
         * static.teams.microsoft.com
         * *.arkoselabs.com
         * *.funcaptcha.com
         * *.adnxs.com
         * *.aolcdn.com
         * fabriciss.azureedge.net
         * connect.facebook.net
         */
        createScript: string => string, // warning: this is unsafe!
    });
}
